import { useTranslation } from "react-i18next";
import styles from "./Answer.module.css";

interface AnswerLoadingProps {
    /** Optional progress message streamed from the backend (e.g. "Querying web-search…"). */
    status?: string;
}

export const AnswerLoading = ({ status }: AnswerLoadingProps) => {
    const { t } = useTranslation();

    return (
        <div className={styles.answerContainer}>
            <div className={styles.loadingBar}>
                <span className={styles.loadingDot} />
                <span className={styles.loadingDot} />
                <span className={styles.loadingDot} />
            </div>
            <p className={styles.loadingLabel}>{status || t("generatingAnswer")}</p>
        </div>
    );
};
